import React from 'react';
import { createRoot } from 'react-dom/client';
import * as Sentry from '@sentry/react';
import App from './App.jsx';

// ─── Sentry error monitoring ──────────────────────────────────────────────────
Sentry.init({
  dsn: import.meta.env.VITE_SENTRY_DSN,
  environment: import.meta.env.MODE,           // "production" or "development"
  enabled: !!import.meta.env.VITE_SENTRY_DSN,  // only runs when DSN is set
  tracesSampleRate: 0.2,                        // capture 20% of transactions
  replaysOnErrorSampleRate: 1.0,               // always capture replay on error
  integrations: [
    Sentry.replayIntegration({
      maskAllText: false,
      blockAllMedia: false,
    }),
  ],
});

// ─── Error fallback screen ────────────────────────────────────────────────────
function ErrorFallback({ error }) {
  return (
    <div style={{
      padding: 24,
      fontFamily: 'sans-serif',
      color: '#2d1f14',
      background: '#faf7f2',
      minHeight: '100vh',
    }}>
      <h1>Platewise couldn't load</h1>
      <p>Something went wrong. Try refreshing the page.</p>
      <pre style={{
        whiteSpace: 'pre-wrap',
        background: 'white',
        padding: 16,
        borderRadius: 8,
        fontSize: 13,
        color: '#b91c1c',
      }}>
        {String(error?.message || error)}
      </pre>
      <button
        onClick={() => window.location.reload()}
        style={{ marginTop: 16, padding: '10px 20px', cursor: 'pointer' }}
      >
        Reload
      </button>
    </div>
  );
}

// ─── Render ───────────────────────────────────────────────────────────────────
createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <Sentry.ErrorBoundary fallback={ErrorFallback}>
      <App />
    </Sentry.ErrorBoundary>
  </React.StrictMode>,
);
